export const SITE_ORIGIN = 'https://equinord.dk';

export function absoluteUrl(path: string): string {
  if (!path || path === '/') return `${SITE_ORIGIN}/`;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized.replace(/\/$/, '')}`;
}

export function getProductPath(product: { id: number; path?: string }): string {
  const slug = (product.path || '').replace(/^\/+|\/+$/g, '');
  return slug ? `/produkt/${product.id}/${slug}` : `/produkt/${product.id}`;
}

export function getProductUrl(product: { id: number; path?: string }): string {
  return absoluteUrl(getProductPath(product));
}

export function canonicalPath(pathname?: string): string {
  const path = pathname || (typeof window !== 'undefined' ? window.location.pathname : '/');
  if (!path || path === '/') return `${SITE_ORIGIN}/`;
  return `${SITE_ORIGIN}${path.replace(/\/$/, '')}`;
}
